import {
    createImage,
    getFileDataURL,
    getPdfPageFromFile,
    resizeImageFile,
    isPasswordProtected,
    generateUniqueId
} from "./file-functions";

class InputFile {
    constructor(file) {
        this.name = file.name;
        this.size = file.size;
        this.lastModified = file.lastModified;

        this._file = file;
        this._dataUrl = null;
        this.uploadedFileData = {};
        this.multipleFiles = false;
        this.identifier = "";
    }

    async dataUrl() {
        !this._dataUrl && (this._dataUrl = await getFileDataURL(this._file));
        return this._dataUrl;
    }

    setUniqueId() {
        this.identifier = generateUniqueId();
    }

    toFile() {
        if (!this._dataUrl) {
            throw new Error("Data URL not set");
        }
        var arr = this._dataUrl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], this.name, { type: mime });
    }

    get extension() {
        return (
            this._file.name &&
            this._file.name
                .split(".")
                .pop()
                .toLowerCase()
        );
    }
}

class InputImage extends InputFile {
    constructor(file) {
        super(file);
        this._img = null;
    }

    hasValidExtension() {
        return ["jpg", "jpeg", "png"].includes(this.extension);
    }

    async load() {
        const url = await this.dataUrl();
        this._img = await createImage(url);
    }

    async width() {
        !this._img && (await this.load());
        return this._img.width;
    }
    async height() {
        !this._img && (await this.load());
        return this._img.height;
    }
    async resize(width, height, mimeType, quality) {
        return resizeImageFile(this._file, {
            width,
            height,
            mimeType,
            quality
        });
    }
}

class InputPdf extends InputFile {
    hasValidExtension() {
        return ["pdf"].includes(this.extension);
    }

    async isPasswordProtected() {
        return await isPasswordProtected(this._file);
    }

    async pageImage(page) {
        return await getPdfPageFromFile(this._file, page);
    }
}

export { InputFile, InputImage, InputPdf };
